
import { $t } from '@/i18n';
export const PermissionType = {
  MODULE: 'module',
  API: 'api',
  PAGE: 'page',
  SET: 'set',
  MCP: 'mcp',
};
export const PermissionTypeMap = {
  [PermissionType.MODULE]: $t('k_aa07e056'),
  [PermissionType.PAGE]: $t('k_9701c2ec'),
  [PermissionType.API]: $t('k_3f9c7e13'),
  [PermissionType.SET]: $t('k_4d6c5b12'),
  [PermissionType.MCP]: 'MCP',
};
export const PermissionTypeDesc = {
  [PermissionType.MODULE]: $t('k_f6e68ca8'),
  [PermissionType.PAGE]: $t('k_8f71bb05'),
  [PermissionType.API]: $t('k_dc7d645c'),
  [PermissionType.SET]: $t('k_dbd89e4e'),
  [PermissionType.MCP]: $t('k_9fbdbc0a'),
};
export const API_PERMISSION_BINDING_TYPE = 'cloud-function';
export const COLLECTION_BINDING_TYPE = 'collection-cgi';
export const MCP_BINDING_TYPE = 'collection-cgi-from-mcp';
export const ApiType = {
  SCF: API_PERMISSION_BINDING_TYPE,
  CGI: COLLECTION_BINDING_TYPE,
  MCP: MCP_BINDING_TYPE,
};
export const MODULE = 'rbac';
export const ADMIN_ROLE_ID = 'project.admin';
export const GUEST_ROLE_ID = 'project.guest';
export const GUEST_ROLE_NAME = '已登录用户';
export const UNLOGIN_GUEST_ROLE_ID = 'project.unlogin';
export const BIZ_OR_PROJECT = '-_ALL_-';

export const READ_PAGE = 'read.page';
export const CREATE_PAGE = 'create.page';
export const UPDATE_PAGE = 'update.page';
export const DELETE_PAGE = 'delete.page';
export const UPLOAD_PAGE = 'upload.page';
export const START_FLOW = 'start.flow';
export const UPLOAD_FLOW = 'upload.flow';

export const APPLY_WORKFLOW_ID = 'general-permission-apply-workflow';

// 仅为菜单权限设置而保留
export const PAGE_MAPPING_PERMS = [
  READ_PAGE,
  CREATE_PAGE,
  UPDATE_PAGE,
  DELETE_PAGE,
];

export const PAGE_PERMISSIONS = [
  ...PAGE_MAPPING_PERMS,
  UPLOAD_PAGE,
];

export const RELATED_PERMISSIONS = [
  ...PAGE_PERMISSIONS,
  START_FLOW,
  UPLOAD_FLOW,
];

export const PAGE_PERM_MAPPING = {
  [READ_PAGE]: $t('k_72288ae6'),
  [CREATE_PAGE]: $t('k_d27542c4'),
  [UPDATE_PAGE]: $t('k_f6f2bdda'),
  [DELETE_PAGE]: $t('k_31802b06'),
  [UPLOAD_PAGE]: $t('k_7a6784c1'),
};

export const pagePermissionTooltip = {
  [READ_PAGE]: {
    name: $t('k_58775278'),
    tooltip: $t('k_a6db7578'),
    warn: $t('k_77114af3'),
  },
  [CREATE_PAGE]: {
    name: $t('k_697b3a2c'),
    tooltip: $t('k_d398b57f'),
    warn: $t('k_541cf25b'),
  },
  [UPDATE_PAGE]: {
    name: $t('k_92dc87c4'),
    tooltip: $t('k_9bdfd184'),
    warn: $t('k_7f12cdee'),
  },
  [DELETE_PAGE]: {
    name: $t('k_3c26b6cc'),
    tooltip: $t('k_222b9012'),
    warn: $t('k_3a988fdd'),
  },
  [UPLOAD_PAGE]: {
    name: $t('k_7a6784c1'),
    tooltip: $t('k_755292ba'),
    warn: $t('k_c0a30a4d'),
  },
};

export const BUILT_IN_ROLES = [
  ADMIN_ROLE_ID,
  GUEST_ROLE_ID,
  UNLOGIN_GUEST_ROLE_ID,
  'project.participant',
  'page.admin',
  'page.guest',
];

export const NAMESPACED = 'perm';

export default {};
